export function cap(s) {
  return (s || "").toString().replace(/[-_]/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
}

/**
 * Small read-only "here's what this pick actually grants you" blurb — pulled straight from the
 * compendium data (senses, speed, resistances, key ability, etc.) so players don't have to leave
 * the sheet or consult a book to remember what their ancestry/class/race/background does.
 */
export default function TraitBlurb({ description, facts, testId }) {
  if (!description && (!facts || facts.length === 0)) return null;
  return (
    <div data-testid={testId} className="mt-1.5 bg-black/25 border border-[#4a3424]/40 rounded-lg p-2 space-y-1.5">
      {description && <p className="text-[10px] text-[#f1e0c5]/60 italic leading-snug">{description}</p>}
      {facts && facts.length > 0 && (
        <div className="flex flex-wrap gap-1">
          {facts.map((f, i) => (
            <span key={i} className="text-[9px] uppercase tracking-wide bg-[#D4AF37]/10 text-[#D4AF37] px-1.5 py-0.5 rounded-full border border-[#D4AF37]/20">{f}</span>
          ))}
        </div>
      )}
    </div>
  );
}
